// extracted by mini-css-extract-plugin
export default {"tooltip":"lsf-tooltip","before-appear":"lsf-before-appear","before-disappear":"lsf-before-disappear","appear":"lsf-appear","visible":"lsf-visible","disappear":"lsf-disappear","tooltip_align_top-center":"lsf-tooltip_align_top-center","tooltip_align_bottom-center":"lsf-tooltip_align_bottom-center"};
    if(module.hot) {
      // 1637785517390
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  